import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';
import { NAVIGATION_HEIGHT, NAVIGATION_HEIGHT_MOBILE } from 'consts';
import SearchInputHeader from './components/SearchInputHeader';
import SideNav from './components/SideNav';
import DropdownNav from './components/DropdownNav';
import Questions from './components/Questions';
import HeaderBg from './components/HeaderBg';

export const PolicyPage = styled.div`
  display: grid;
  grid-template-rows: ${NAVIGATION_HEIGHT_MOBILE}px 90px 80px auto 1fr;
  grid-template-areas:
    'navbg'
    'titleheader'
    'searchinputheader'
    'dropdownnav'
    'content'
    'contact';
  min-height: calc(100vh - 180px);
  background-color: ${th('colors.white')};

  ${({ isLoading }) =>
    isLoading &&
    css`
      grid-template-areas:
        'navbg'
        'titleheader'
        'searchinputheader'
        'loading';
    `}

  @media ${sizes.tabletPortrait} {
    grid-template-rows: ${NAVIGATION_HEIGHT}px 100px 100px auto 1fr;
  }

  @media ${sizes.desktop} {
    grid-template-rows: ${NAVIGATION_HEIGHT}px 80px 100px auto 1fr;
    grid-template-columns: 300px 1fr;
    grid-template-areas:
      'navbg navbg'
      'titleheader titleheader'
      'searchinputheader searchinputheader'
      'sidenav content'
      'stickycontact content';

    ${({ isLoading }) =>
      isLoading &&
      css`
        grid-template-areas:
          'navbg navbg'
          'titleheader titleheader'
          'searchinputheader searchinputheader'
          'loading loading';
      `}
  }

  @media ${sizes.extraLargeDesktop} {
    grid-template-rows: ${NAVIGATION_HEIGHT}px 80px 110px 1fr;
    grid-template-columns: 400px 1fr;
  }
`;

export const NavBg = styled.div`
  grid-area: navbg;
  position: fixed;
  width: 100%;
  height: ${NAVIGATION_HEIGHT_MOBILE}px;
  background-color: ${th('colors.blue')};
  z-index: 2;

  @media ${sizes.tabletPortrait} {
    height: ${NAVIGATION_HEIGHT}px;
  }
`;

export const StyledHeaderBg = styled(HeaderBg)`
  z-index: 1;
`;

export const TitleHeader = styled.div`
  grid-area: titleheader;
  position: relative;
  padding: 10px 20px 0 20px;
  background-color: ${th('colors.blue')};
  z-index: 1;

  @media ${sizes.desktop} {
    padding-top: 30px;
  }

  @media ${sizes.largeDesktop} {
    padding: 30px 40px 0 40px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding-left: 80px;
  }

  > h1 {
    color: ${th('colors.white')};
    letter-spacing: 0;

    @media ${sizes.mobileMedium} {
      font-size: 29px;
    }

    @media ${sizes.tabletPortrait} {
      font-size: 40px;
    }
  }
`;

export const StyledSearchInputHeader = styled(SearchInputHeader)`
  grid-area: searchinputheader;
`;

export const StyledSideNav = styled(SideNav)`
  grid-area: sidenav;
  display: none;

  @media ${sizes.desktop} {
    display: flex;
  }
`;

export const StyledDropdownNav = styled(DropdownNav)`
  grid-area: dropdownnav;
  display: block;
  z-index: ${th('zIndexes.dropdown')};

  @media ${sizes.desktop} {
    display: none;
  }
`;

export const StyledQuestions = styled(Questions)`
  grid-area: content;
  overflow: hidden;
  max-width: 1200px;
`;

export const LoadingContainer = styled.div`
  grid-area: loading;
  position: relative;
  z-index: 0;
`;

export const DownloadLink = styled.a`
  display: none;
  position: absolute;
  right: 80px;
  bottom: 0;
  text-decoration: none;
  color: ${th('colors.white')};

  @media ${sizes.extraLargeDesktop} {
    display: block;
  }
`;
